<template>
    <div>
        <form @submit.prevent="submit" ref="addItem">
            <div class="row">
                <form-input
                    v-model="denuncia.nome_vitima"
                    grid="6"
                    label="Nome da vítima"
                />
                <form-input
                    v-model="denuncia.idade_vitima"
                    type="number"
                    grid="3"
                    label="Idade da vítima"
                />
                <form-calendar
                    v-model="denuncia.data_denuncia"
                    grid="3"
                    label="Data da denúncia"
                    :required="true"
                />
                <form-calendar
                    v-model="denuncia.data_prevista"
                    grid="3"
                    label="Data Prevista Resposta"
                />
                <form-select
                    v-model="denuncia.canal_denuncia"
                    grid="6"
                    label="Canal de recebimento"
                    :itens="$root.arrays.canal_denuncia"
                    :required="true"
                />
                <form-select
                    v-model="denuncia.denunciante"
                    grid="3"
                    label="Denunciante"
                    :itens="$root.arrays.denunciate"
                    :required="true"
                />
                <form-input
                    v-model="denuncia.denunciante_nome"
                    grid="6"
                    :required="true"
                    label="Nome do denunciante"
                    v-if="denuncia.denunciante == 6"
                />
                <form-input
                    v-model="denuncia.denunciante_telefone"
                    grid="3"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    :required="true"
                    label="Telefone do denunciante"
                    v-if="denuncia.denunciante == 6"
                />
                <form-input
                    v-model="denuncia.denunciante_data_nascimento"
                    grid="3"
                    v-mask="'##/##/####'"
                    placeholder="00/00/0000"
                    label="Data de nasc. do denunciante"
                    v-if="denuncia.denunciante == 6"
                />
                <form-input
                    v-model="denuncia.denunciante_endereco"
                    label="Endereço do denunciante"
                    v-if="denuncia.denunciante == 6"
                />
                <form-toggle
                    v-model="showEncaminhamento"
                    grid="12"
                    label="Encaminhar para unidade"
                />
            </div>
            <div class="row" v-if="showEncaminhamento">
                <form-select
                    v-model="denuncia.unidade_destino_id"
                    label="Unidade"
                    grid="6"
                    :itens="unidades"
                    :required="true"
                    btn-icon="mdi mdi-plus"
                    @input="getTecnicos(denuncia.unidade_destino_id)"
                    :disabled="loadUnidades"
                    :loading="loadUnidades"
                />

                <form-select
                    :disabled="disabledUser"
                    :loading="loadUser"
                    v-model="denuncia.user_destino_id"
                    label="Destinatário"
                    grid="6"
                    :itens="tecnicos"
                    btn-icon="mdi mdi-plus"
                />
            </div>
            <div class="row">
                <form-textarea-editor
                    v-model="denuncia.descricao"
                    label="Descrição da ocorrência"
                    :required="true"
                />
                <form-textarea
                    v-model="denuncia.endereco_denuncia"
                    label="Endereço da ocorrência"
                />
                <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: "Add",
    data() {
        return {
            denuncia: { data_denuncia: null },
            files: [],
            progressCompleted: 0,
            showEncaminhamento: false,
            loadUnidades: true,
            loadUser: false,
            disabledUser: true,
            unidades: [],
            tecnicos: [],
        };
    },
    mounted() {
        this.getUnidades();
    },
    methods: {
        getUnidades() {
            this.loadUnidades = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => {
                    this.loadUnidades = false;
                });
        },
        getTecnicos(unidade_id) {
            this.loadUser = true;
            this.disabledUser = true;
            axios
                .get(`api/dashboard/tecnicos/get/externos/${unidade_id}`)
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadUser = false;
                    this.disabledUser = false;
                });
        },
        submitFile(files) {
            this.files = files;
        },
        submit() {
            // if (this.denuncia.data_denuncia) {
            //   this.denuncia.data_denuncia = moment(
            //     this.denuncia.data_denuncia,
            //     "YYYY-MM-DD"
            //   ).format("DD/MM/YYYY");
            // }
            // if (this.denuncia.denunciante_data_nascimento) {
            //   this.denuncia.denunciante_data_nascimento = moment(
            //     this.denuncia.denunciante_data_nascimento,
            //     "YYYY-MM-DD"
            //   ).format("DD/MM/YYYY");
            // }
            let formData = new FormData();
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }

            for (var key in this.denuncia) {
                formData.append(key, this.denuncia[key]);
            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/denuncias`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Denúncia cadastrada com sucesso.",
                    });
                    this.$router.push(
                        `/dashboard/denuncias/edit/${response.data.id}`
                    );
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
